import { getViewedId } from '@api/semrush/integration.api';
import { MetadataType } from '@ts/common.types';
import { INTEGRATION_MODES, isSemrushMode, isStandaloneMode } from '@constants/app-modes';
import { getRealm } from '@utils/realmIdentifier';
import { RealmType } from 'respona_api/generated/common_pb';
import { getItemFromStorage } from '@utils/localStorageHandler';

export const getIntegrationModeByRealm = (): string => {
  if (isSemrushMode()) {
    return INTEGRATION_MODES.SEMRUSH;
  }

  switch (getRealm()) {
    case RealmType.RESPONA_CONCIERGE:
      return INTEGRATION_MODES.RESPONA_CONCIERGE;
    case RealmType.RESPONA_APP:
      return INTEGRATION_MODES.RESPONA_APP;
    case RealmType.RESPONA_PUBLISHER:
      return INTEGRATION_MODES.RESPONA_PUBLISHER;
    default:
      throw new Error(`Unrecognized App type: ${getRealm()}`);
  }
};

const fetchMetadata = (needAuthHeaders: boolean = true): Promise<MetadataType> => {
  const metadata: MetadataType = {};
  metadata['X-REALM'] = getIntegrationModeByRealm();
  if (!needAuthHeaders) {
    return Promise.resolve(metadata);
  }
  if (isStandaloneMode()) {
    const existingToken = getItemFromStorage('token');
    if (existingToken == null) {
      return Promise.reject();
    }
    metadata.Authorization = existingToken.toString();
    return Promise.resolve(metadata);
  }
  if (isSemrushMode()) {
    return getViewedId().then((authToken) => {
      metadata.Authorization = authToken;
      return metadata;
    });
  }
  return Promise.reject();
};

export default fetchMetadata;
